<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="过程数据"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
   
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
    
      @create-opened="createOpened"
    
    >
     <template slot="form">
      
       
           <el-row>
            <el-col :span="12">
              <el-form-item label="模数" prop="Cycn">
                 {{data.Cycn}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="周期时间" prop="Ecyct">
                 {{data.Ecyct}}
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="射出起点" prop="Eiss">
                 {{data.Eiss}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大射速" prop="Eivm">
                 {{data.Eivm}}
              </el-form-item>
            </el-col>
              <el-col :span="12">
              <el-form-item label="最大射压" prop="Eipm">
                 {{data.Eipm}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="转保压时间" prop="Esipt">
                 {{data.Esipt}}
              </el-form-item>
            </el-col>
            

             <el-col :span="12">
              <el-form-item label="转保压压力" prop="Esipp">
                 {{data.Esipp}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="转保压位置" prop="Esips">
                 {{data.Esips}}
              </el-form-item>
            </el-col>
              <el-col :span="12">
              <el-form-item label="射出时间" prop="Eipt">
                 {{data.Eipt}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="射出终点位置" prop="Eipse">
                 {{data.Eipse}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="储料时间" prop="Eplst">
                 {{data.Eplst}}
              </el-form-item>
            </el-col>   


          <el-col :span="12">
              <el-form-item label="储料终点" prop="Eplsse">
                 {{data.Eplsse}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大储料压力" prop="Eplspm">
                 {{data.Eplspm}}
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="生产温度1" prop="Et1">
                 {{data.Et1}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产温度2" prop="Et2">
                 {{data.Et2}}
              </el-form-item>
            </el-col>
              <el-col :span="12">
              <el-form-item label="生产温度3" prop="Et3">
                 {{data.Et3}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产温度4" prop="Et4">
                 {{data.Et4}}
              </el-form-item>
            </el-col>
            

             <el-col :span="12">
              <el-form-item label="生产温度5" prop="Et5">
                 {{data.Et5}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产温度6" prop="Et6">
                 {{data.Et6}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产温度7" prop="Et7">
                 {{data.Et7}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产温度8" prop="Et8">
                 {{data.Et8}}
              </el-form-item>
            </el-col>

             <el-col :span="12">
              <el-form-item label="生产温度9" prop="Et9">
                 {{data.Et9}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产温度10" prop="Et10">
                 {{data.Et10}}
              </el-form-item>
            </el-col>


           </el-row>
      
       
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
 
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
     
     api: require('@/api/equipment/processdata').default,
      data: {
        Cycn: null,
        Ecyct: null,
        Eiss: null,
        Eivm: null,
        Eipm: null,
        Esipt: null,
        Esipp: null,
        Esips: null,
        Eipt: null,
        Eipse: null,
        Eplst: null,
        Eplsse: null,
        Eplspm: null,

        Et1: null,
        Et2: null,
        Et3: null,
        Et4: null,
        Et5: null,
        Et6: null,
        Et7: null,
        Et8: null,
        Et9: null,
        Et10: null,


      },
    
   
    };
  },
  methods: {
                   
  },
};
</script>
